// Preserve server-provided user-facing errors; callers supply localized fallbacks.
export const getErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;

const gameErrorTranslationKeys = {
    E_MSG_0001: 'gameRoom.errors.serverError',
    E_MSG_0002: 'gameRoom.errors.roomNotFound',
    E_MSG_0003: 'gameRoom.errors.nameAlreadyExist',
    E_MSG_0004: 'gameRoom.errors.invitePlayers',
    E_MSG_0005: 'roomEntry.roomFull',
    E_MSG_0006: 'gameRoom.errors.notEnoughCards',
    E_MSG_0007: 'gameRoom.errors.cannotDiscardNextPlayerPickCard',
    E_MSG_0008: 'gameRoom.errors.cannotDiscardPickedCard',
    E_MSG_0009: 'gameRoom.errors.maximumPickedCards',
    E_MSG_0010: 'gameRoom.errors.cannotChangeSetting',
    E_MSG_0011: 'gameRoom.errors.cannotSwapWhilePlaying',
    E_MSG_0012: 'gameRoom.errors.cannotPickPairWithoutWin',
    E_MSG_0013: 'gameRoom.playerNameRequired',
};

// Game APIs return stable message IDs alongside English diagnostic text. UI
// must translate the ID and use the diagnostic text only for logs/debugging.
export const getGameErrorMessage = (error, t, fallback) => {
    const data = error?.response?.data;
    const key = gameErrorTranslationKeys[data?.messageId || data?.code];
    return key ? t(key) : fallback;
};

// Translate account errors without exposing English-only server messages.
export const getAccountErrorMessage = (error, t, fallbackKey) => {
    const keys = {
        E_AUTH_0002: 'invalidVerificationCode', E_AUTH_0003: 'verificationCodeExpired',
        E_AUTH_0007: 'passwordRequirements', E_AUTH_0014: 'passwordMismatch',
        E_AUTH_0005: 'usernameAlreadyTaken', E_AUTH_0015: 'invalidUsername',
        E_AUTH_0016: 'currentPasswordIncorrect', E_AUTH_0022: 'tooManyAttempts',
        E_AUTH_0024: 'passwordSetupUnavailable',
    };
    const key = keys[error?.response?.data?.messageId];
    return t(key ? `auth.errors.${key}` : fallbackKey);
};
